import { fetchUrl } from './settings';
import { ActionType } from '../action-types';
import {IDateObject} from "../../helpers/interfaces";
import { getNodes } from './actions';
import { getSystemFull } from './dashboardActions';
import date from "date-and-time";

export const base = (
    nodeID: number,
    newBase: number,
    updatedViaWebsiteAt: string,
    systemId: number
) => dispatch => {
    dispatch({ type: ActionType.EDITING_TOGGLE })

    let token = localStorage.getItem('w4-token');
    if (newBase === undefined || newBase === "") {
        throw Error("RAMBO")
    }
    return fetch(`${fetchUrl}/node/base`, {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ nodeID, newBase, updatedViaWebsiteAt }),
    })
        .then(resp => resp.json())
        .then(data => {
            dispatch({ type: ActionType.BASE_NODE, payload: data })
        })
        .then(res => {
          dispatch(getSystemFull(systemId));
        })
        .catch(err => console.log(err))
        .finally(() => {
            dispatch({ type: ActionType.EDITING_TOGGLE })
        })
}

export const configureNode = (
    nodeID: number,
    threshold: number,
    l1: number,
    l2: number,
    l3: number,
    l4: number,
    updatedViaWebsiteAt: string,
    inclinometerInverted: boolean,
    systemId: number
) => dispatch => {
    dispatch({ type: ActionType.EDITING_TOGGLE })

    let token = localStorage.getItem('w4-token');
    return fetch(`${fetchUrl}/node/configure`, {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ nodeID, threshold, l1, l2, l3, l4, updatedViaWebsiteAt, inclinometerInverted }),
    })
        .then(resp => resp.json())
        .then(data => {
            dispatch({ type: ActionType.CONFIGURE_NODE, payload: data })
        })
        .then(res => {
          dispatch(getSystemFull(systemId));
        })
        // .catch(err => console.error(err))
        .finally(() => {
            dispatch({ type: ActionType.EDITING_TOGGLE })
        })
}

export const baseAndWaitForRecalc = (
  nodeID: number,
  newBase,
  updatedViaWebsiteAt,
  systemId: number,
  nodeName: string
) => async (dispatch) => {
  dispatch({ type: ActionType.IS_NODE_RECALCULATED, isRecalculated: false, nodeName: nodeName });

  try {
    await dispatch(base(nodeID, newBase, updatedViaWebsiteAt, systemId));

    const token = localStorage.getItem('w4-token');
    const checkRecalculation = async () => {
      try {
        const resp = await fetch(`${fetchUrl}/node/is-recalculated/${nodeID}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const data = await resp.json();

        if (data.isRecalculated) {
          await dispatch(getNodes([systemId]));
          dispatch({ type: ActionType.IS_NODE_RECALCULATED, isRecalculated: true, nodeName: nodeName });
        } else {
          // Continue polling every 5 seconds until isRecalculated is true
          setTimeout(checkRecalculation, 5000);
        }
      } catch (error) {
        console.error('Polling error:', error);
      }
    };
    checkRecalculation();
  } catch (error) {
    console.error('Error in base function:', error);
  }
};

export const accelerateNode = (
    nodeID: number,
    updatedViaWebsiteAt: string,
    newAcceleratedUntil: string|null
) => dispatch => {
    dispatch({ type: ActionType.EDITING_TOGGLE })
    let token = localStorage.getItem('w4-token');
    return fetch(`${fetchUrl}/node/accelerate`, {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ nodeID, updatedViaWebsiteAt, newAcceleratedUntil }),
    })
        .then(resp => resp.json())
        .then(data => {
            dispatch({ type: ActionType.ACCELERATE_NODE, payload: data })
        })
        .finally(() => {
            dispatch({ type: ActionType.EDITING_TOGGLE })
        })
}

export const setNodeActive = (
  nodeID: number,
  active: boolean,
  updatedViaWebsiteAt: string,
) => dispatch => {
  dispatch({ type: ActionType.EDITING_TOGGLE })

  let token = localStorage.getItem('w4-token');

  return fetch(`${fetchUrl}/node/set-active`, {
      method: 'PATCH',
      headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({ nodeID, active, updatedViaWebsiteAt }),
  })
      .then(resp => resp.json())
      .then(data => {
          dispatch({ type: ActionType.SET_NODE_ACTIVE, payload: data })
      })
      .catch(err => console.log(err))
      .finally(() => {
          dispatch({ type: ActionType.EDITING_TOGGLE })
      })
}